import styled from "styled-components";

export const InputComponent = styled.input`
  border-bottom-width: 1px;
  border-bottom-color: #000;
  :focus {
    outline: none;
  }
`;
